import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Divider from '@mui/material/Divider'
import { useTranslation } from 'react-i18next'

const today = new Date()
const formattedDate = today.toLocaleDateString('en-US', {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric'
})

export default function Updates() {
  const { t } = useTranslation('raceGuide')
  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant='h4' gutterBottom>
        {t('updates.title')}
      </Typography>

      <Card elevation={3} sx={{ marginBottom: 3 }}>
        <CardContent>
          <Typography variant='h5' component='div' gutterBottom>
            {t('updates.headline')}
          </Typography>

          <Typography
            variant='subtitle2' gutterBottom sx={{
            color: 'text.secondary'
          }}
          >
            {t('updates.announcementDate', { date: formattedDate })}
          </Typography>

          <Divider sx={{ marginY: 2 }} />

          <Typography variant='body1' paragraph>
            {t('updates.intro')}
          </Typography>

          <Typography variant='h6' gutterBottom>
            {t('updates.transportTitle')}
          </Typography>

          <Typography variant='body1' paragraph>
            {t('updates.transport1')}
          </Typography>

          <Typography variant='body1' paragraph>
            {t('updates.transport2')}
          </Typography>

          <Typography variant='body1' paragraph>
            {t('updates.transport3')}
          </Typography>

          <Typography variant='h6' gutterBottom>
            {t('updates.bibTitle')}
          </Typography>

          <Typography variant='body1' paragraph>
            {t('updates.bib1')}
          </Typography>

          <Typography variant='body1' paragraph>
            {t('updates.bib2')}
          </Typography>

          <Typography variant='h6' gutterBottom>
            {t('updates.weatherTitle')}
          </Typography>

          <Typography variant='body1' paragraph>
            {t('updates.weather1')}
          </Typography>

          <Typography variant='body1' paragraph>
            {t('updates.weather2')}
          </Typography>

          <Typography variant='h6' gutterBottom>
            {t('updates.bibLocTitle')}
          </Typography>

          <Typography variant='subtitle1' gutterBottom>
            {t('updates.fridayBib')}
          </Typography>
          <Typography variant='body1' paragraph sx={{ whiteSpace: 'pre-line' }}>
            {t('updates.fridayLocation')}
          </Typography>

          <Typography variant='subtitle1' gutterBottom>
            {t('updates.sundayBib')}
          </Typography>
          <Typography variant='body1' paragraph sx={{ whiteSpace: 'pre-line' }}>
            {t('updates.sundayLocation')}
          </Typography>

          <Typography variant='h6' gutterBottom sx={{ color: 'orange' }}>
            {t('updates.shuttleTitle')}
          </Typography>

          <Typography variant='body1'>
            {t('updates.shuttleNote')}
          </Typography>

          <Divider sx={{ marginY: 2 }} />

          <Typography variant='body1' paragraph>
            {t('updates.thanks')}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  )
}
